import React from 'react';
import { withRouter } from 'react-router-dom';
import VisuelInfos from "../visuels/infos.jpg";

class Accueil extends React.Component {


    redirectToHome = () => {
        const {history} = this.props;
        if (history) history.push('/');
    };

    redirectToInfo = () => {
        const { history } = this.props;
        if(history) history.push('/infos');
    }


    redirectToBack = () => {
        const {history} = this.props;
        if (history) history.goBack();
    };



    render() {
        const { history } = this.props;
        return  (
            <div>
                <img src={VisuelInfos} alt="Choix des pieces" style={{width:1280}} useMap="#image-map"/>

                <map name="image-map">
                    <area onClick={this.redirectToHome} alt="" title="Accueil"   coords=" 0,1200,630,0" shape="rect"/>
                    <area onClick={ this.redirectToHome} alt="" title="Accueil"  coords="1400,900,650,-1" shape="rect"/>
                    <area onClick={this.redirectToHome} alt="" title="Accueil" coords="850,1200,950,900" shape="rect"/>
                    <area onClick={this.redirectToBack} alt="" title="Page précédente" coords="970,1200,1090,900" shape="rect"/>
                    <area onClick={this.redirectToInfo} alt="" title="Infos" coords="1100,1200,1250,900" shape="rect"/>
                </map>
            </div>);
    }

}

export default withRouter(Accueil);